import { useParams } from 'react-router-dom';
import TitleBar from '../../../../../components/TitleBar';
import { Footer } from '../../../../../components/common/Footer';
import { DisasterRecoveryTable } from '..';
import useBCPMetaData from '../../../../../hooks/useBCPMetaData';
import FetchError from '../../../../../components/generic/FetchError';
import { Loading } from '../../../../../components';
import TitleUpdater from '../../../../../components/common/TitleUpdater';

export default function DisasterRecoveryPlan() {
  const params = useParams();
  const { type, locationId } = params;

  const isLocationType = type === 'location';

  const { planUUID, locationName, loading, error } = useBCPMetaData(
    locationId!,
    isLocationType,
  );

  const backPath = `/bcp-landing/${type}/${locationId}`;

  if (loading) return <Loading />;

  if (error) return <FetchError error={error.message} />;

  return (
    <div>
      <TitleUpdater title={`Disaster Recovery Plans`} />
      <TitleBar
        title="BCP Hub"
        subtitle="Disaster Recovery Plans"
        brief="List critical applications that support the company. For each application, indicate whether
                       a disaster recovery plan exists, and what the current service level agreement is to restore the
                       application in the event of a disruption."
      />

      <DisasterRecoveryTable planUUID={planUUID} />
      <Footer backPath={backPath} />
    </div>
  );
}
